import { ReactNode, useMemo } from 'react';
import { ApolloProvider } from '@apollo/client/react';
import { getDefaultGraphqlClient } from '@core/api/graphqlClient';
import { TenantShopsProvider } from '@core/tenant/TenantShopsContext';
import { ApolloClientsProvider } from '@core/context/ApolloClientsContext';
import { IdentityBrokerProvider } from '@core/commerce/identity/identityBroker';
import { CartProvider } from '@features/cart/context/CartContext';
import { AuthProvider } from '@features/auth/context/AuthContext';
import { WishlistProvider } from '@features/wishlist/context/WishlistContext';
import { EventSdkUserSync } from '@core/events';
import { CatalogProvider } from '@core/catalog/CatalogProvider';
import { CategoriesProvider } from '@core/catalog/CategoriesProvider';

interface AppProviderProps {
  children: ReactNode;
}

/**
 * Main app provider component
 * Add global providers here (Theme, Auth, State Management, etc.)
 */
export const AppProvider = ({ children }: AppProviderProps) => {
  const apolloClient = useMemo(() => getDefaultGraphqlClient(), []);
  return (
    <ApolloProvider client={apolloClient}>
      <TenantShopsProvider>
        <ApolloClientsProvider>
          <AuthProvider>
            <CatalogProvider>
              <CategoriesProvider>
              <IdentityBrokerProvider>
                <CartProvider>
                  <WishlistProvider>
                    <EventSdkUserSync />
                    {children}
                  </WishlistProvider>
                </CartProvider>
              </IdentityBrokerProvider>
              </CategoriesProvider>
            </CatalogProvider>
          </AuthProvider>
        </ApolloClientsProvider>
      </TenantShopsProvider>
    </ApolloProvider>
  );
};

